import { createContext, useContext } from 'react';

import { CommonApplicationServices } from './CommonApplicationServices';

export const CommonApplicationServicesContext = createContext<CommonApplicationServices | null>(
  null,
);

export const useCommonAppServices = () => {
  return useContext(CommonApplicationServicesContext);
};
